import React, { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { API_BASE_URL } from "src/config/apiBase";
import { decryptToken } from "../utils/getToken";
import { toast } from "react-toastify";

const DIMENSIONS = [
  { id: "source", label: "Source" },
  { id: "stage", label: "Stage" },
  { id: "city", label: "City" },
  { id: "rep", label: "Rep" },
];

const CrmReportBuilder = ({ days = 30 }) => {
  const [dimension, setDimension] = useState("source");
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(false);
  const url = API_BASE_URL;
  const token = decryptToken("accessToken") || "";

  const load = () => {
    setLoading(true);
    fetch(`${url}/leads/reports/build?dimension=${dimension}&days=${days}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => (r.ok ? r.json() : null))
      .then(setReport)
      .finally(() => setLoading(false));
  };

  useEffect(load, [dimension, days, url, token]);

  const downloadCsv = async () => {
    try {
      const res = await fetch(
        `${url}/leads/reports/build?dimension=${dimension}&days=${days}&format=csv`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (!res.ok) throw new Error("Export failed");
      const blob = await res.blob();
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `crm-${dimension}-${days}d.csv`;
      link.click();
      URL.revokeObjectURL(link.href);
    } catch {
      toast.error("CSV export failed");
    }
  };

  return (
    <div className="crm-report-builder">
      <div className="crm-integrations__head">
        <strong>Report builder</strong>
        <button type="button" onClick={downloadCsv}>
          <Download size={14} /> Export CSV
        </button>
      </div>
      <p className="crm-insights__muted">Group leads by dimension for the last {days} days.</p>

      <div className="crm-report-builder__dims">
        {DIMENSIONS.map((d) => (
          <button
            key={d.id}
            type="button"
            className={dimension === d.id ? "active" : ""}
            onClick={() => setDimension(d.id)}
          >
            {d.label}
          </button>
        ))}
      </div>

      {loading && <p className="crm-insights__muted">Building report…</p>}

      {report?.rows?.length > 0 && (
        <table className="crm-attribution__table">
          <thead>
            <tr>
              <th>{report.dimensionLabel}</th>
              <th>Leads</th>
              <th>Converted</th>
              <th>Pipeline</th>
              <th>Rate</th>
            </tr>
          </thead>
          <tbody>
            {report.rows.map((row) => (
              <tr key={row.label}>
                <td>{row.label}</td>
                <td>{row.count}</td>
                <td>{row.converted}</td>
                <td>₹{row.pipeline_value?.toLocaleString("en-IN")}</td>
                <td>{row.conversion_rate}%</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default CrmReportBuilder;
